import { render, staticRenderFns } from "./DigitalParecerCardiologico.vue?vue&type=template&id=1394fa48&scoped=true"
import script from "./DigitalParecerCardiologico.vue?vue&type=script&lang=js"
export * from "./DigitalParecerCardiologico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394fa48",
  null
  
)

export default component.exports